'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _class, _temp;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _translate = require('@esnpm/translate');

var _ESForm = require('../ESForm');

var _BaseInput2 = require('./BaseInput');

var _BaseInput3 = _interopRequireDefault(_BaseInput2);

var _PlusIcon = require('mdi-react/PlusIcon');

var _PlusIcon2 = _interopRequireDefault(_PlusIcon);

var _redux = require('redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanguageAdd = function (_React$Component) {
	_inherits(LanguageAdd, _React$Component);

	function LanguageAdd() {
		_classCallCheck(this, LanguageAdd);

		return _possibleConstructorReturn(this, (LanguageAdd.__proto__ || Object.getPrototypeOf(LanguageAdd)).apply(this, arguments));
	}

	_createClass(LanguageAdd, [{
		key: 'handleOnClick',
		value: function handleOnClick() {
			var lc = this.refs.langSelect.value;
			this.props.onAdd(lc);
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.props.availableLanguages.length == 0) return null;
			var options = this.props.availableLanguages.map(function (lc) {
				return _react2.default.createElement(
					'option',
					{ key: lc, value: lc },
					lc
				);
			});

			return _react2.default.createElement(
				'tr',
				{ className: 'ESFormGroup' },
				_react2.default.createElement(
					'td',
					{ className: 'ESFieldInput', style: { 'display': 'inline-flex' } },
					_react2.default.createElement(
						_reactBootstrap.InputGroup,
						{ style: { 'width': '130px' } },
						_react2.default.createElement(
							'select',
							{ className: 'form-control', ref: 'langSelect' },
							options
						),
						_react2.default.createElement(
							_reactBootstrap.InputGroup.Button,
							null,
							_react2.default.createElement(
								_reactBootstrap.Button,
								{
									className: 'InputGroupButton',
									onClick: this.handleOnClick.bind(this)
								},
								'\xA0',
								_react2.default.createElement(_PlusIcon2.default, null)
							)
						)
					),
					_react2.default.createElement(
						'span',
						{ style: { 'paddingLeft': '10px' } },
						_react2.default.createElement(_translate.Tr, { path: 'esforms.languageAdd' })
					)
				)
			);
		}
	}]);

	return LanguageAdd;
}(_react2.default.Component);

var Translation = (_temp = _class = function (_BaseInput) {
	_inherits(Translation, _BaseInput);

	function Translation(props) {
		_classCallCheck(this, Translation);

		var _this2 = _possibleConstructorReturn(this, (Translation.__proto__ || Object.getPrototypeOf(Translation)).call(this, props));

		_this2.state = Object.assign({}, _this2.state, {
			availableLanguages: _this2.getAvailableLanguages(_this2.state.val)
		});
		return _this2;
	}

	_createClass(Translation, [{
		key: 'getAvailableLanguages',
		value: function getAvailableLanguages(val) {
			var lcInData = Object.keys(val);
			var lcAvailable = Object.values(this.props.availableLanguages);
			lcAvailable = lcAvailable.sort();
			if (lcInData.length == 1) {
				lcAvailable.push('ALL');
			}
			var lcUnassigned = lcAvailable.filter(function (lc) {
				return !lcInData.includes(lc);
			});
			return lcUnassigned;
		}
	}, {
		key: 'handleOnChange',
		value: function handleOnChange() {
			var val = this.refs.translation.wrappedInstance.value();
			this.setVal(val);
		}
	}, {
		key: 'handleRemoveLanguage',
		value: function handleRemoveLanguage(languageCode) {
			var newVal = Object.assign({}, this.state.val);
			delete newVal[languageCode];
			this.setValWithLanguages(newVal);
		}
	}, {
		key: 'setValWithLanguages',
		value: function setValWithLanguages(val) {
			var _this3 = this;

			Promise.resolve(this.setState({
				val: val,
				availableLanguages: this.getAvailableLanguages(val)
			})).then(function () {
				_this3.triggerOnChange(val);
			});
		}
	}, {
		key: 'handleAddLanguage',
		value: function handleAddLanguage(languageCode) {
			var newVal = Object.assign({}, this.state.val);
			var lcInData = Object.keys(newVal);

			if (languageCode == 'ALL') {
				if (lcInData.length == 1) {
					// Wenn ALL geadded wird und eine Übersetzung vorhanden ist, dann
					// soll diese in ALL umgewandelt werden.
					newVal = { "ALL": newVal[lcInData[0]] };
				} else {
					newVal[languageCode] = '';
				}
			} else {
				if (lcInData.length == 1 && lcInData[0] == "ALL") {
					// Wenn ALL die einzige Übersetzung ist, dann soll der LC gewchselt werden
					newVal = _defineProperty({}, languageCode, newVal["ALL"]);
				} else {
					newVal[languageCode] = '';
				}
			}

			this.setValWithLanguages(newVal);
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				_ESForm.ESForm,
				{ ref: 'translation',
					noValidationClassChange: this.props.noValidationClassChange,
					noValidationLabelClassChange: this.props.noValidationLabelClassChange
				},
				this.renderLanguageTexts(),
				this.renderNoTranslationAvailable(),
				this.renderAddButton()
			);
		}
	}, {
		key: 'renderAddButton',
		value: function renderAddButton() {
			return _react2.default.createElement(LanguageAdd, { onAdd: this.handleAddLanguage.bind(this), availableLanguages: this.state.availableLanguages });
		}
	}, {
		key: 'renderLanguageTexts',
		value: function renderLanguageTexts() {
			var _this4 = this;

			return Object.entries(this.state.val).map(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 2),
				    cc = _ref2[0],
				    text = _ref2[1];

				return _react2.default.createElement(_ESForm.ESForm.LanguageText, {
					key: cc,
					languageCode: cc,
					fieldName: cc,
					onChange: _this4.handleOnChange.bind(_this4),
					onRemove: _this4.handleRemoveLanguage.bind(_this4),
					value: text,
					size: _this4.props.size,
					maxLength: _this4.props.maxLength
				});
			});
		}
	}, {
		key: 'handleOnClick',
		value: function handleOnClick(e) {
			this.handleOnChange(e);
		}
	}, {
		key: 'renderNoTranslationAvailable',
		value: function renderNoTranslationAvailable() {

			if (Object.keys(this.state.val).length === 0) {
				return _react2.default.createElement(
					'tr',
					null,
					_react2.default.createElement(
						'td',
						{ className: "NoTranslationAvailable" },
						_react2.default.createElement(
							'span',
							null,
							_react2.default.createElement(_translate.Tr, { path: "esforms.noTranslationAvailable" })
						)
					)
				);
			}
		}
	}]);

	return Translation;
}(_BaseInput3.default), _class.propTypes = Object.assign({}, _BaseInput3.default.propTypes, {
	value: _propTypes.PropTypes.object
}), _temp);
exports.default = (0, _redux.compose)()(Translation);